import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Module-level singleton — one fetch for all pages
let _cache = null;
let _promise = null;

function loadConfigs() {
  if (_cache) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = fetch(`${API}/page-hero`)
      .then(r => (r.ok ? r.json() : {}))
      .catch(() => ({}))
      .then(data => { _cache = data; return data; });
  }
  return _promise;
}

function isImageKit(url) {
  return typeof url === 'string' && url.startsWith('https://ik.imagekit.io/');
}

/**
 * Returns a validated ImageKit URL for the given page slug,
 * or null if the field is empty / not a valid ImageKit URL.
 */
export function useHeroImage(slug) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    loadConfigs().then(cfg => {
      const raw = (cfg[slug] || '').trim();
      setUrl(isImageKit(raw) ? raw : null);
    });
  }, [slug]);
  return url;
}
